import axios from 'axios'
import type {
  PolicyDetailResponse,
  PolicyFilters,
  PolicyListRequest,
  PolicyListResponse,
  PolicyStatusCountsResponse,
} from 'types'

export const policyList = (request: PolicyListRequest) =>
  axios
    .get<PolicyListResponse>('/api/policies', { params: request })
    .then((res) => res.data)

export const policyCount = (filters?: PolicyFilters) =>
  axios
    .get<PolicyStatusCountsResponse>('/api/policies/count', {
      params: { filters },
    })
    .then((res) => res.data)

export const policyGet = (policyUuid: string) =>
  axios
    .get<PolicyDetailResponse>(`/api/policies/${policyUuid}`)
    .then((res) => res.data)

export const POLICY_EXPORT_ENDPOINT = '/api/policies/export'
